import React, {useEffect, useState} from "react";
import ImageInput from "../../Components/Inputs/ImageInput";
import {useFieldArray} from "react-hook-form";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import TextInput from "../../Components/Inputs/TextInput";
import {BANNER_TYPES} from "../../Constants/Constants";

export default function ({control, errors, data, watch, register}) {
  const {fields} = useFieldArray({
    control,
    name: "images",
    keyName: "index",
  });

  const type = watch('type');

  return (
    <div className="card card-flush py-4 mt-3">
      <h3 className="text-danger text-center">ატვირთული ფოტოების ზომები უნდა იყოს რეკომენდირებული ზომების ტოლი ან მათი პროპორციული</h3>
      <div className="card-header">
        <div className="card-title">
          <h2>Images</h2>
        </div>
        {errors?.images && (
          <div className="fv-plugins-message-container invalid-feedback mb-5">
            <div>{errors.images}</div>
          </div>
        )}
      </div>
      <div className="card-body pt-0">
        <div className="fv-row">
          {fields.map((item, index) => {
            const bannerSize = BANNER_TYPES?.[type]?.sizes?.[index];
            const desktopLabel = bannerSize?.desktop ? (bannerSize?.desktop.width + ' x ' + bannerSize?.desktop.height + ' pixels') :  '';
            const mobileLabel = bannerSize?.mobile ? (bannerSize?.mobile.width + ' x ' + bannerSize?.mobile.height + ' pixels') : '';

            return <div key={item.index} className="d-flex align-items-center justify-content-around gap-1 mb-3">
              {item?.id && (
                <input
                  type="hidden"
                  {...register(`images.${index}.id`)}
                />
              )}

              <div className='w-50'>
                <ImageInput
                  label={`Desktop image (${desktopLabel})`}
                  name={`images.${index}.desktop_image`}
                  errorMessage={errors?.[`images.${index}.desktop_image`]}
                  control={control}
                  defaultValue={item.desktop_image}
                  id={`images.${index}.desktop_image`}
                />
              </div>

              <div className='w-50'>
                <ImageInput
                  label={`Mobile image (${mobileLabel})`}
                  name={`images.${index}.mobile_image`}
                  control={control}
                  errorMessage={errors?.[`images.${index}.mobile_image`]}
                  defaultValue={item.desktop_image}
                  id={`images.${index}.mobile_image`}
                />
              </div>

              <div className='w-50'>
                <TextInput
                  label='Url'
                  name={`images.${index}.url`}
                  control={control}
                  register={register}
                  errorMessage={errors?.[`images.${index}.url`]}
                />
              </div>

              <ReactSelectInput
                label="Shop"
                name={`images.${index}.shop_id`}
                control={control}
                errorMessage={errors?.[`images.${index}.shop_id`]}
                options={data?.shops}
                inputClassName='w-50'
              />
            </div>
          })}
        </div>
      </div>
    </div>
  );
}